<template>
  <authenticate-to-continue-modal :title="title" :description="description"
                                  :authentication-modal-data="authenticationModalData"
                                  :sign-in-button-text="i18n.t('member.petitions.start.authenticate_to_publish_modal.sign_in_submit')"
                                  :sign-up-button-text="i18n.t('member.petitions.start.authenticate_to_publish_modal.sign_up_submit')"
                                  :confirmation-warning-message="confirmationWarningMessage"
                                  @authenticated="publish"
                                  @user-awaiting-confirmation="linkCampaignWithUnconfirmedUser" />
</template>

<script>
import AuthenticateToContinueModal from '@/users/authenticate-to-continue-modal'
import { mapActions, mapState } from 'vuex'

export default {
  components: { AuthenticateToContinueModal },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    confirmationWarningMessage: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState(['authenticationModalData'])
  },

  methods: {
    ...mapActions(['publish', 'linkCampaignWithUnconfirmedUser'])
  }
}
</script>
